import { BaseApiClient } from '../client'
import type { CommissionTier, CreateTierInput, UpdateTierInput } from '../types'

export class CommissionTiersApi extends BaseApiClient {
  async list() {
    return this.request<CommissionTier[]>('/api/admin/commission-tiers')
  }

  async get(id: string) {
    return this.request<CommissionTier>(`/api/admin/commission-tiers/${id}`)
  }

  async seedDefaults() {
    return this.request<CommissionTier[]>('/api/admin/commission-tiers/seed-defaults', {
      method: 'POST',
    })
  }

  async create(data: CreateTierInput) {
    return this.request<CommissionTier>('/api/admin/commission-tiers', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async update(id: string, data: UpdateTierInput) {
    return this.request<CommissionTier>(`/api/admin/commission-tiers/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
  }
}
